import ACTION from "../../config/constants/action";

const changeLanguage = (lang) => {
  return {
    type: ACTION.CHANGE_LANGUAGE,
    payload: lang,
  };
};

export default changeLanguage;